module.exports = __webpack_public_path__ + "img/FairfaxLogo.7f218aed.svg";